import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StudentAssignmentModel } from 'common/models/page-models/Student Assignment/student-assignment-data.model';
import { StudentAssignmentListingModel } from 'common/models/page-models/Student Assignment/student-assignment-grid-model';

import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentAssignmentGridWidgetService } from 'common/widget/Student Assignment/student-assignment-widget.service';


 
@Injectable({
    providedIn: 'root'
})
export class StudentAssignmentGridResolver extends GridResolver<StudentAssignmentModel, StudentAssignmentListingModel> {
    constructor(
        protected fs: StudentAssignmentGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
       
    }
    

    
}